import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  API_BASE_URL,
  GET_USER_STORES,
  INSERT_INVENTORY_PRODUCT,
  GET_BARCODE_TYPE,
} from "../../../Config";
import Axios from "axios";
import Swal from "sweetalert2";
import JsBarcode from "jsbarcode";

const AddProductInventory = () => {
  const [userDataSession, setUserDataSession] = useState(null);
  const [unitsData, setUnitsData] = useState([]);
  const [productsData, setProductsData] = useState([]); // From sessionStorage
  const [storesData, setStoresData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [weight, setWeight] = useState("");
  const [mfgDate, setMfgDate] = useState("");
  const [expDate, setExpDate] = useState("");
  const [printBarcodeDataUI, setPrintBarcodeDataUI] = useState({});
  const [barcodeFieldData, setBarcodeFieldData] = useState(null); // From barcode API

  // Load user data and DDLs from sessionStorage
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const units = JSON.parse(sessionStorage.getItem("filteredDDLData_UNITS"));
    const products = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Products")
    );

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setUnitsData(units || []);
      setProductsData(products || []);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  // Fetch stores and barcode UI template
  useEffect(() => {
    if (userDataSession?.OrgId && userDataSession?.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setStoresData(response.data.ResultData);
          }
        })
        .catch((error) => {
          console.error("Error fetching stores:", error);
        });
      Axios.get(
        `${API_BASE_URL}${GET_BARCODE_TYPE}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setPrintBarcodeDataUI(response.data.ResultData[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching barcode UI:", error);
        });
    }
  }, [userDataSession]);

  // Fetch barcode details (MRP, Barcode, etc.) when product is selected
  useEffect(() => {
    if (selectedProduct?.value && userDataSession?.OrgId) {
      const productId = selectedProduct.value;
      Axios.get(
        `${API_BASE_URL}Product/GetBarcodeFields?OrgId=${
          userDataSession.OrgId
        }&ProductId=${productId}&StoreId=${selectedStore?.value || 0}`
      )
        .then((res) => {
          if (res.data.Status && res.data.ResultData?.length) {
            const data = res.data.ResultData[0];
            setBarcodeFieldData(data);

            // Update selectedProduct with latest MRP and Barcode
            setSelectedProduct((prev) => ({
              ...prev,
              MRP: data.MRP,
              BarCode: data.Barcode || batchNo || `TEMP-${Date.now()}`,
            }));
          } else {
            setBarcodeFieldData(null);
            setSelectedProduct((prev) => ({
              ...prev,
              MRP: null,
              BarCode: null,
            }));
          }
        })
        .catch((err) => {
          console.error("Error fetching barcode fields:", err);
          setBarcodeFieldData(null);
        });
    } else {
      setBarcodeFieldData(null);
    }
  }, [selectedProduct?.value, userDataSession, batchNo]);

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    setSelectedProduct(null);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption); // Will trigger barcode API in useEffect
  };

  const handleUnitChange = (selectedOption) => {
    setSelectedUnit(selectedOption);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

const handlePrintBarcode = (item) => {
  console.log("Printing barcode with data:", item);
  const tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  document.body.appendChild(tempSvg);

  JsBarcode(tempSvg, item.BarCode || "123456789", {
    format: "CODE128",
    lineColor: "#000",
    width: 2,
    height: 40,
    displayValue: true,
  });

  setTimeout(() => {
    const barcodeSVG = tempSvg.outerHTML.replace(
      "<svg",
      '<svg width="450px" height="100px"'
    );

    const printContent = printBarcodeDataUI?.HtmlString?.replaceAll("#ORGNAME#", item.StoreName || "")
      .replaceAll("#ITEMNAME#", item.ProductName || "")
      .replaceAll("#WEIGHT#", item.Weight || "")
      .replaceAll("#UNITS#", item.Units || "")
      .replaceAll("#MFGDATE#", formatDate(item.MfgDate) || "")
      .replaceAll("#EXPIRYDATE#", formatDate(item.ExpiryDate) || "")
      .replaceAll("#ITEMPRICE#", item.MRP || "")
      .replaceAll("#PHNO#", item.PhoneNumber || "")
      .replaceAll("#BARCODEIMG#", barcodeSVG);

    document.body.removeChild(tempSvg);

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Please allow popups for printing barcode.");
      return;
    }

    printWindow.document.write(`
      <html>
        <head><title>Print Barcode</title></head>
        <body>${printContent}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.onfocus = () => {
      setTimeout(() => {
        printWindow.close();
        
        window.location.reload();
      }, 300); 
    };
  }, 300);
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedStore || !selectedProduct || !mfgDate || !expDate) {
      Swal.fire({
        title: "Missing Fields",
        text: "Please fill in all required fields.",
        icon: "warning",
      });
      return;
    }

    const requestData = {
      OrgId: userDataSession.OrgId,
      ProductId: selectedProduct.value,
      StoreId: selectedStore.value,
      VariantId: selectedUnit ? selectedUnit.value : null,
      Quantity: parseFloat(quantity) || 0,
      Weight: parseFloat(weight) || 0,
      BatchNo: batchNo || null,
      IsActive: true,
      MfgDate: mfgDate,
      ExpiryDate: expDate,
      CreatedBy: userDataSession.UserId,
    };

    Axios.post(`${API_BASE_URL}${INSERT_INVENTORY_PRODUCT}`, requestData)
      .then((response) => {
         console.log(response,"barcode calling response");
        if (response.status === 200) {
          Swal.fire({
            title: "Product Added Successfully",
            icon: "success",
          }).then(() => {
            const barcodeData = {
              StoreName: selectedStore?.label || "",
              ProductName: selectedProduct?.label || "",
              Weight: weight || "",
              Units: selectedUnit?.label || "",
              MfgDate: mfgDate,
              ExpiryDate: expDate,
              MRP: selectedProduct?.MRP || "",
              PhoneNumber: barcodeFieldData?.StorePhoneNo || "",
              BarCode:
                response.data[0]?.BarCode ||
                selectedProduct?.BarCode ||
                batchNo ||
                `TEMP-${Date.now()}`,
            };

           
            handlePrintBarcode(barcodeData);
            setSelectedStore(null);
            setSelectedProduct(null);
            setSelectedUnit(null);
            setQuantity("");
            setBatchNo("");
            setWeight("");
            setMfgDate("");
            setExpDate("");
          });
        }
      })
      .catch((error) => {
        console.error("Error adding product:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to add product.",
          icon: "error",
        });
      });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };

  const productOptions = productsData.map((prod) => ({
    value: prod.ItemId,
    label: prod.DisplayValue || prod.ItemValue,
  }));

  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddProdInventory"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Add Product Inventory
          </h4>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6 mb-2">
                <label className="form-label">
                  Store<span className="fw-semibold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  onChange={handleStoreChange}
                  options={storesData.map((store) => ({
                    value: store.StoreId,
                    label: store.Name,
                  }))}
                  styles={customStyles}
                  placeholder="Choose store"
                  value={selectedStore}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">
                  Product<span className="fw-semibold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  onChange={handleProductChange}
                  options={productOptions}
                  placeholder="Choose product"
                  styles={customStyles}
                  value={selectedProduct}
                  isDisabled={!productsData.length}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">Quantity</label>
                <input
                  className="form-control"
                  type="number"
                  placeholder="Enter qty"
                  onChange={(e) => setQuantity(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                  value={quantity}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">BatchNo</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setBatchNo(e.target.value)}
                  placeholder="Enter batchno"
                  value={batchNo}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">Weight</label>
                <input
                  className="form-control"
                  type="number"
                  placeholder="Enter weight"
                  onChange={(e) => setWeight(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                  value={weight}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">Units</label>
                <Select
                  className="select"
                  onChange={handleUnitChange}
                  options={unitsData.map((unit) => ({
                    value: unit.ItemId,
                    label: unit.ItemValue,
                  }))}
                  styles={customStyles}
                  value={selectedUnit}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">
                  MFG Date<span className="fw-semibold text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="date"
                  onChange={(e) => setMfgDate(e.target.value)}
                  value={mfgDate}
                />
              </div>
              <div className="col-lg-6 mb-2">
                <label className="form-label">
                  EXP Date<span className="fw-semibold text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="date"
                  onChange={(e) => setExpDate(e.target.value)}
                  value={expDate}
                />
              </div>
            </div>
            <div className="modal-footer-btn">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddProductInventory;
